import { render, staticRenderFns } from "./productResume.html?vue&type=template&id=682f9142&scoped=true&"
import script from "./productResume.js?vue&type=script&lang=js&"
export * from "./productResume.js?vue&type=script&lang=js&"
import style0 from "./productResume.scss?vue&type=style&index=0&id=682f9142&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "682f9142",
  null
  
)

export default component.exports